import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 sm:px-6 py-6 text-center">
      {/* контент ограничен по ширине и центрирован */}
      <div className="z-10 w-full max-w-xl sm:max-w-2xl">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold mb-3 sm:mb-4 text-gray-800 drop-shadow">
          Добро пожаловать!
        </h1>

        <p className="text-base sm:text-lg md:text-xl leading-relaxed text-gray-700 mx-auto mb-8 sm:mb-10 px-1 sm:px-0">
          Здесь вы можете тренировать навыки работы с Excel и Google Sheets,
          проходя интерактивные тесты. Проверьте свои знания и прокачайте навыки!
        </p>

        {/* блок с кнопками: колонка на мобиле, ряд на больших; одинаковый размер */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center">
          <button
            onClick={() => navigate("/quiz")}
            className="w-full sm:w-64 py-4 sm:py-5 px-6 bg-green-500 text-white text-lg sm:text-2xl rounded-xl shadow-xl hover:bg-green-600 transition"
          >
            Пройти тест
          </button>

          <button
            onClick={() => navigate("/practice")}
            className="w-full sm:w-64 py-4 sm:py-5 px-6 bg-blue-500 text-white text-lg sm:text-2xl rounded-xl shadow-xl hover:bg-blue-600 transition"
          >
            Потренироваться в тренажёре
          </button>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
